import React from "react";
import ReactDOM from "react-dom";
import AppMain from "./AppMain.js";

ReactDOM.render(
  <AppMain />,
  document.getElementById("root")
);
